var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 24.875C19.5024 24.875 24.875 19.5024 24.875 12.875C24.875 6.24758 19.5024 0.875 12.875 0.875C6.24758 0.875 0.875 6.24758 0.875 12.875C0.875 19.5024 6.24758 24.875 12.875 24.875Z",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 16.875C15.6364 16.875 17.875 14.6364 17.875 11.875C17.875 9.11358 15.6364 6.875 12.875 6.875C10.1136 6.875 7.875 9.11358 7.875 11.875C7.875 14.6364 10.1136 16.875 12.875 16.875Z",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84996 21.8C5.60235 20.318 6.75041 19.0734 8.16689 18.2039C9.58337 17.3345 11.2129 16.8742 12.875 16.8742C14.537 16.8742 16.1666 17.3345 17.583 18.2039C18.9995 19.0734 20.1476 20.318 20.9 21.8",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.29275c7394c4ea9bea5fd710f9ed7eae.svg";
export { ForwardRef as ReactComponent };